var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-alert',{staticClass:"main-alert",attrs:{"show":_vm.alert.dismissCountDown,"fade":"","variant":_vm.alert.type,"dismissible":""},on:{"dismissed":_vm.hide}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.alert.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }